<template>
    <b-pagination class="products-view__pagination justify-content-center"
                  v-model="pagination.currentPage" pills
                  :total-rows="pagination.totalRows"
                  :per-page="pagination.perPage"
                  @change="onPageChanged" size="sm"></b-pagination>
</template>

<script type="text/javascript">

    import { mapState } from 'vuex'

    export default {
        computed: {
          ...mapState('pageModule', ['pagination'])
        },
        methods: {
            onPageChanged(e) {
                this.$store.commit("pageModule/SET_PAGE", e);
            }
        },
    }
</script>